import { REPORTS_ROLLOUT_FLAG } from '@borradh-workspace/contracts';
import { useMemo } from 'react';

import { useReportsAvailability } from '@/features/reports/api';

/**
 * The `featureFlag` keys the dashboard navigation may show, for the sidebar
 * and the mobile More tab alike. Server-answered, so a section never appears
 * whose page or API would refuse the clinic.
 */
export function useEnabledNavFlags(): ReadonlySet<string> {
  const { reportsEnabled } = useReportsAvailability();
  return useMemo(
    () => new Set(reportsEnabled ? [REPORTS_ROLLOUT_FLAG] : []),
    [reportsEnabled]
  );
}
